export default __webpack_public_path__ + "static/media/y.9454d134.svg";